import { inr } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export const DeliveryRules = ({ area }) => {
  if (!area) return null;
  const fee = area.delivery_fee || 0;
  const min = area.min_order || 0;
  return (
    <span className="text-xs text-stone-500" data-testid={`area-rules-${area.pincode}`}>
      {fee > 0 ? `Delivery ${inr(fee)}` : "Free delivery"}{min > 0 ? ` · Min order ${inr(min)}` : ""}
    </span>
  );
};

export const MinOrderNotice = () => {
  const { shortBy, minOrder, area } = useStore();
  if (shortBy <= 0) return null;
  return (
    <div className="rounded-xl bg-accent/10 text-accent text-sm font-semibold px-4 py-3" data-testid="min-order-notice">
      Add {inr(shortBy)} more to reach the {inr(minOrder)} minimum order for {area?.pincode}.
    </div>
  );
};

export const FeeLines = () => {
  const { subtotal, deliveryFee, total } = useStore();
  return (
    <div className="space-y-1 text-sm">
      <div className="flex justify-between"><span>Subtotal</span><span data-testid="fee-subtotal">{inr(subtotal)}</span></div>
      <div className="flex justify-between"><span>Delivery fee</span>
        <span data-testid="fee-delivery" className={deliveryFee ? "font-semibold" : "text-secondary font-semibold"}>{deliveryFee ? inr(deliveryFee) : "Free"}</span>
      </div>
      <div className="flex justify-between text-lg font-extrabold text-primary"><span>Total</span><span data-testid="fee-total">{inr(total)}</span></div>
    </div>
  );
};
